import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import MainPage from '../views/MainPage.vue'
import ImagesMainPage from '../views/ImagesMainPage.vue'
import OCRValidation from '../views/OCRValidation.vue'
import Users from '../views/Users.vue'
import Projects from '../views/Projects.vue'
import Batches from '../views/Batches.vue'
import Annotation from '../views/Annotation.vue'
import NotFound from '../views/404.vue'
import ProjectUsers from '../views/ProjectUsers.vue'
import ProjectFields from '../views/ProjectFields.vue'
import BatchesUsers from '../views/BatchesUsers.vue'
import UploadedImages from '../views/UploadedImages.vue'
import OCR from '../views/OCR.vue'
import SearchName from '../views/SearchName.vue'


Vue.use(VueRouter)

export const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/ocr-validation',
    name: 'ocr-validation',
    component: OCRValidation,
  },
  {
    path: '/main-page',
    name: 'Main Page',
    component: MainPage,
  },
  // {
  //   path: "/main-page-images",
  //   name: "Image Main Page",
  //   component: ImagesMainPage,
  // },
  {
    path: '/users',
    name: 'Users',
    component: Users,
  },

  {
    path: '/projects',
    name: 'Projects',
    component: Projects,
  },

  {
    path: '/Annotation',
    name: 'Annotation',
    component: Annotation,
  },

  {
    path: '/batches',
    name: 'Batches',
    component: Batches,
  },
  {
    path: '/UploadedImages',
    name: 'UploadedImages',
    component: UploadedImages,
  },
  {
    path: '/projects/:projectId/users',
    component: ProjectUsers,
    children: [{ path: '', component: ProjectUsers }],
  },
  {
    path: '/projects/:projectId/fields',
    component: ProjectFields,
    children: [{ path: '', component: ProjectFields }],
  },
  {
    path: '/batches/:batchId/images',
    component: ImagesMainPage,
  },
  {
    path: '/batches/:batchId/users',
    component: BatchesUsers,
    children: [{ path: '', component: BatchesUsers }],
  },
  {
    path: '/SearchName',
    name: 'SearchName',
    component: SearchName,
  },
  {
    path: '/OCR',
    name: 'OCR',
    component: OCR,
  },
  {
    path: '*',
    name: 'Not Found',
    component: NotFound,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
